<script>
import options from './StafetDeltagPaaHoldStepTwo.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-join-a-team-step-two kb-optimizely-forms"
  >
    <div>
      <h2 class="kb-stafet-step__title">
        {{ labels.taendEtLysTitle }}
      </h2>
      <p class="kb-stafet-step__description">
        {{ labels.taendEtLysDescription }}
      </p>
    </div>

    <AdvancedRadio
      v-if="!isCustomAmount"
      fieldName="donationAmount"
      :modelValue="donationAmount.toString()"
      v-model="donationAmount"
      :radioOptions="editorControlledDonationAmountList"
      :legend="labels.taendEtLysSelectQuantityLabel"
      label=""
      :isRequired="true"
      :onChangeCallback="(input) => setDonationAmount(input)"
    ></AdvancedRadio>

    <div class="kb-stafet-step__input-wrapper">
      <div class="kb-stafet-step__input-wrapper">
        <div>
          <button class="kb-link" v-on:click="chooseCustomAmount">
            {{ labels.taendEtLysSelectCustomQuantityLabel }}
          </button>
        </div>

        <FormInputTextField
          v-if="isCustomAmount"
          :modelValue="donationAmount.toString()"
          v-model="donationAmount"
          label=""
          fieldName="donationAmount"
          type="number"
          :onChangeCallback="(e) => setDonationAmount(e.target.value)"
        />
      </div>

      <p
        class="Form__Element__ValidationError"
        v-if="showDonationAmoutErrorMessage"
      >
        {{ labels.taendEtLysSelectQuantityErrorMessage }}
      </p>
    </div>

    <SupportSelector
      :stafetId="stafetId"
      :labels="labels"
      :displayInputError="displayInputError"
      :onChangeCallback="updateSupportSelector"
      :holdList="holdList"
    />

    <FormInputTextField
      :modelValue="donationPerLightBag.toString()"
      v-model="donationPerLightBag"
      :label="labels.taendEtLysSelectAmountLabel"
      :isRequired="true"
      fieldName="donationPerLightBag"
      type="number"
      :isValidationError="showDonationPerLightBagErrorMessage"
      :placeholder="labels.taendEtLysSelectAmountPlaceholder"
      :errorMessageLabel="labels.taendEtLysSelectAmountErrorMessage"
      :onChangeCallback="(e) => setDonationPerLightBag(e.target.value)"
    />

    <div v-if="donationAmount > 0">
      <h2>{{ labels.taendEtLysCustomizeLysposeTitle }}</h2>

      <StafetLysPoserList
        :labels="StafetFlowLightBagsMetaListLabels"
        :numberOfDonations="donationAmount"
        :onChangeCallback="updateLightBagMeta"
        :displayInputError="displayInputError"
        :data="donationAmountList"
        :isLysposerDedicated="isLysposerDedicated"
        :addPersonalNote="addPersonalNote"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep2"
      :skipStepCallback="skipStepCallback"
      :skipStepLabel="labels.formNavigationSkipStep"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPrevStep"
    />
  </article>
</template>
